export const DEFAULT_WELCOME_MESSAGE = 'Thank you for waiting, I will be with you shortly.';
export const DEFAULT_UNAVAILABLE_MESSAGE = 'I am currently unavailable. If this is an emergency, please call 911.';
